<template>
<!--  <page-header-wrapper>-->
    <a-modal
      :visible="visible"
      width="80%"
      :footer="null"
      style="padding: 20px"
      @cancel="cancel">
      <!-- 条件搜索 -->
      <a-divider orientation="left">
      </a-divider>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <a-col :md="5" :sm="24">-->
<!--              <a-form-item label="视频id" prop="videoId">-->
<!--                <a-input v-model="queryParam.videoId" placeholder="请输入视频id" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('videoPerformer.performerNameDe')" prop="performerName">
                <a-input v-model="queryParam.performerName" :placeholder="$t('videoPerformer.inputPerformerName')" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
<!--              <a-col :md="5" :sm="24">-->
<!--                <a-form-item label="演员头像" prop="performerAvatar">-->
<!--                  <a-input v-model="queryParam.performerAvatar" placeholder="请输入演员头像? allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="5" :sm="24">-->
<!--                <a-form-item label="排序" prop="sort">-->
<!--                  <a-input v-model="queryParam.sort" placeholder="请输入排序? allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="5" :sm="24">-->
<!--                <a-form-item label="是否禁用 0-否?1-是? prop="isBan">-->
<!--                  <a-input v-model="queryParam.isBan" placeholder="请输入是否禁用?0-否?1-是? allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- v-hasPermi="['videoPerformer:videoPerformer:add']" -->
        <a-button type="primary" @click="$refs.createForm.handleAdd(videoId)">
          <a-icon type="plus" />{{ $t('common.add') }}
        </a-button>
<!--        <table-setting-->
<!--          style="float: right"-->
<!--          :table-size.sync="tableSize"-->
<!--          v-model="columns"-->
<!--          :refresh-loading="loading"-->
<!--          @refresh="getList" />-->
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <img style="width: 48px;height: 48px;" v-image-preview :src="record.performerAvatar" slot="performerAvatar" slot-scope="text, record">
        <span slot="isBan" slot-scope="text, record">
          <a-switch :checkedChildren="$t('common.enable')" :unCheckedChildren="$t('common.disable')" v-model="!record.isBan" @change="changeIsBan($event,record)"/>
        </span>

        <span slot="operation" slot-scope="text, record">
          <!-- v-hasPermi="['videoPerformer:videoPerformer:edit']" -->
          <a-divider type="vertical" />
          <!-- v-hasPermi="['videoPerformer:videoPerformer:edit']" -->
          <a @click="$refs.createForm.handleUpdate(record, undefined,videoId)">
            <a-icon type="edit" />{{ $t('common.edit') }}
          </a>
          <!-- v-hasPermi="['videoPerformer:videoPerformer:remove']" -->
          <a-divider type="vertical" />
          <!-- v-hasPermi="['videoPerformer:videoPerformer:remove']" -->
          <a @click="handleDelete(record)">
            <a-icon type="delete" />{{ $t('common.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <div class="flex align-center justify-end" style="padding-top: 20px;">
        <a-pagination
          show-size-changer
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => $t('table.total', { total })"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </div>

    </a-modal>
<!--  </page-header-wrapper>-->
</template>

<script>
import { pageVideoPerformer,listVideoPerformer, delVideoPerformer,changeIsBen } from '@/api/videoPerformer/videoPerformer'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'VideoPerformer',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      videoId: '',
      // 高级搜索 展开/关闭
      advanced: false,
      visible: false,
      // 非单个禁用?
      single: true,
      // 非多个禁用?
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        videoId: null,
        performerName: null,
        performerAvatar: null,
        sort: null,
        isBan: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {
  },
  created () {
    // this.getList()
  },
  computed: {
    columns() {
      return [
        // {
        //   title: '${comment}',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '视频id',
        //   dataIndex: 'videoId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('videoPerformer.performerNameDe'),
          dataIndex: 'performerNameDe',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('videoPerformer.performerNameEn'),
          dataIndex: 'performerNameEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('videoPerformer.performerNameFr'),
          dataIndex: 'performerNameFr',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('videoPerformer.performerName'),
          dataIndex: 'performerName',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '演员姓名（西班牙语）',
        //   dataIndex: 'performerNameEs',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('videoPerformer.performerAvatar'),
          dataIndex: 'performerAvatar',
          ellipsis: true,
          scopedSlots: { customRender: 'performerAvatar' },
          align: 'center'
        },
        {
          title: this.$t('table.sort'),
          dataIndex: 'sort',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('common.status'),
          dataIndex: 'isBan',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'isBan' }
        },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  watch: {
  },
  methods: {
    /** 查询视频演员列表 */
    getList () {
      this.loading = true
      this.visible=true
      this.queryParam.videoId=this.videoId
     pageVideoPerformer(this.queryParam).then(response => {
        this.list = response.data.records;
        console.log(this.list);
        this.total = Number(response.data.total);
        this.loading = false
      })
    },

    cancel() {
      this.queryParam.videoId = null
      this.visible = false
    },
    getVideoPerformer(videoId) {
      this.videoId = videoId
      this.getList()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },



    changeIsBan(e, record) {
      record.isBen = e ? false : true
      changeIsBen(record).then(response => {
        this.$message.success(
          this.$t('common.updateSuccess')
        )
        this.getList()
        // eslint-disable-next-line no-return-assign
        return record.isBen = e ? false : true
      })
    },

    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        videoId: undefined,
        performerName: undefined,
        performerAvatar: undefined,
        sort: undefined,
        isBan: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    // onShowSizeChange 方法已在 tableMixin 中统一处理，无需重复定义
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('videoPerformer.confirmDelete'),
        content: this.$t('videoPerformer.confirmDeleteContent') + ids,
        onOk() {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delVideoPerformer(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('common.deleteSuccess'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('videoPerformer.confirmExport'),
        content: this.$t('videoPerformer.confirmExportContent'),
        onOk () {
          that.download('videoPerformer/video-performer/export', {
            ...that.queryParam
          }, `${that.$t('videoPerformer.exportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/table-responsive.less';
</style>
